import intellegenceService from "../shared/services/intellegenceService";
import { setLogout } from "./authActions";

const REQUEST_GET_DASHBOARDS = "REQUEST_GET_DASHBOARDS";
const RESPONSE_GET_DASHBOARDS = "RESPONSE_GET_DASHBOARDS";
const REQUSET_GET_DASHBOARDS_FAILURE = "REQUSET_GET_DASHBOARDS_FAILURE";

const requestGetDashboardsAction = () => {
  return {
    type: REQUEST_GET_DASHBOARDS,
  };
};

const responseGetDashboardsAction = (data) => {
  return {
    type: RESPONSE_GET_DASHBOARDS,
    data,
  };
};

const requestGetDashboardsFailureAction = (errors) => {
  return {
    type: REQUSET_GET_DASHBOARDS_FAILURE,
    errors,
  };
};

const getDashboards = () => {
  return (dispatch) => {
    dispatch(requestGetDashboardsAction());

    intellegenceService
      .getDashboards()
      .then((result) => {
        dispatch(responseGetDashboardsAction(result.data));
      })
      .catch((error) => {
        dispatch(requestGetDashboardsFailureAction(error.response));

        if (error.response && error.response.status === 401) {
          dispatch(setLogout());
        }
      });
  };
};

const REQUEST_GET_DASHBOARDS_CODES = "REQUEST_GET_DASHBOARDS_CODES";
const RESPONSE_GET_DASHBOARDS_CODES = "RESPONSE_GET_DASHBOARDS_CODES";
const REQUSET_GET_DASHBOARDS_FAILURE_CODES = "REQUSET_GET_DASHBOARDS_FAILURE_CODES";

const requestGetDashboardsCodesAction = () => {
  return {
    type: REQUEST_GET_DASHBOARDS_CODES,
  };
};

const responseGetDashboardsCodesAction = (data) => {
  return {
    type: RESPONSE_GET_DASHBOARDS_CODES,
    data,
  };
};

const requestGetDashboardsFailureCodesAction = (errors) => {
  return {
    type: REQUSET_GET_DASHBOARDS_FAILURE_CODES,
    errors,
  };
};

const getDashboardCodes = () => {
  return (dispatch) => {
    dispatch(requestGetDashboardsCodesAction());

    intellegenceService
      .getDashboardCodes()
      .then((result) => {
        dispatch(responseGetDashboardsCodesAction(result.data));
      })
      .catch((error) => {
        dispatch(requestGetDashboardsFailureCodesAction(error.response));

        if (error.response && error.response.status === 401) {
          dispatch(setLogout());
        }
      });
  };
};

export {
  getDashboards,
  requestGetDashboardsAction,
  responseGetDashboardsAction,
  requestGetDashboardsFailureAction,
  REQUEST_GET_DASHBOARDS,
  RESPONSE_GET_DASHBOARDS,
  REQUSET_GET_DASHBOARDS_FAILURE,
  getDashboardCodes,
  requestGetDashboardsCodesAction,
  responseGetDashboardsCodesAction,
  requestGetDashboardsFailureCodesAction,
  REQUEST_GET_DASHBOARDS_CODES,
  RESPONSE_GET_DASHBOARDS_CODES,
  REQUSET_GET_DASHBOARDS_FAILURE_CODES,
};
